module.exports = __webpack_public_path__ + "img/correct-age-for-logical-thinking.6f6ba38.jpg";